var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$env.VUE_APP_DESIGNER)?_c('div',{class:_vm.$style.fake,attrs:{"router-view-symbol":"","designer":_vm.$env.VUE_APP_DESIGNER && _vm.designer}},[_c('router-view')],1):_c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }